import { render, staticRenderFns } from "./_noSistemico.vue?vue&type=template&id=48f508c4&scoped=true&"
import script from "./_noSistemico.vue?vue&type=script&lang=js&"
export * from "./_noSistemico.vue?vue&type=script&lang=js&"
import style0 from "./_noSistemico.vue?vue&type=style&index=0&id=48f508c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f508c4",
  null
  
)

export default component.exports